import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["renderAs", "loading", "noWrap", "variant", "inverted", "size", "mobileSize", "full", "disabled", "className", "iconName", "iconPosition", "children", "dataContentPiece", "dataContentParams"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as A, jsx as v } from "react/jsx-runtime";
import B from "react";
import { c as L } from "../clsx-OuTLNxxd.js";
import { Icon as h } from "../Icon/Icon.js";
import { i as p } from "../checks-C6AyTTQ0.js";
const R = "Button-module_button__PM45p",
  W = "Button-module_size-small__Y--5N",
  T = "Button-module_icon__9MxrK",
  O = "Button-module_icon-right__W5Vh8",
  k = "Button-module_icon-left__cREsW",
  w = "Button-module_icon-only__-y0ze",
  E = "Button-module_no-wrap__00c-U",
  j = "Button-module_variant-inline-text__Xd--1",
  I = "Button-module_full__oaW7Q",
  M = "Button-module_loading__lTBjD",
  D = "Button-module_mobile-size-small__vuRwY",
  H = "Button-module_inverted__d2rMf",
  J = "Button-module_variant-primary__SORsc",
  Q = "Button-module_variant-accent__vvOCQ",
  V = "Button-module_variant-secondary__rccj3",
  Y = "Button-module_variant-elevated__wJicM",
  F = "Button-module_variant-text__LLNyG",
  G = "Button-module_variant-link__Sd8fe",
  t = {
    button: R,
    sizeSmall: W,
    icon: T,
    iconRight: O,
    iconLeft: k,
    iconOnly: w,
    noWrap: E,
    variantInlineText: j,
    full: I,
    loading: M,
    mobileSizeSmall: D,
    inverted: H,
    variantPrimary: J,
    variantAccent: Q,
    variantSecondary: V,
    variantElevated: Y,
    variantText: F,
    variantLink: G
  },
  K = n => p(n.renderAs) ? n.renderAs : "href" in n && p(n.href) ? "a" : "button",
  nt = n => {
    const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderAs: f,
        loading: o,
        noWrap: s,
        variant: e,
        inverted: c,
        size: d,
        mobileSize: m,
        full: i,
        disabled: r,
        className: u,
        iconName: a,
        iconPosition: l = "right",
        children: _,
        dataContentPiece: x,
        dataContentParams: S
      } = n,
      C = _objectWithoutProperties(n, _excluded),
      b = K(n),
      z = x || n["data-content-piece"],
      g = S || n["data-content-params"],
      P = B.Children.toArray(_).filter(y => B.isValidElement(y) || typeof y == "string"),
      N = U({
        className: u,
        size: d,
        mobileSize: m,
        variant: e,
        inverted: c,
        loading: o,
        full: i,
        iconName: a,
        iconPosition: l,
        noWrap: s,
        hasChildren: P.length > 0
      });
    return /* @__PURE__ */A(b, _objectSpread(_objectSpread({
      disabled: r
    }, C), {}, {
      className: N,
      "data-content-piece": z,
      "data-content-params": g ? JSON.stringify(g) : void 0,
      children: [a && l == "left" && /* @__PURE__ */v(h, {
        name: a,
        size: "1.5x",
        wrapperClassName: t.icon,
        padding: !1,
        ariaHidden: !0
      }), _ && /* @__PURE__ */v("span", {
        children: _
      }), a && l == "right" && /* @__PURE__ */v(h, {
        name: a,
        size: "1.5x",
        wrapperClassName: t.icon,
        padding: !1,
        ariaHidden: !0
      })]
    }));
  };
function U(n) {
  const {
    className: f,
    size: o = "regular",
    mobileSize: s,
    variant: e = "primary",
    inverted: c = !1,
    loading: d,
    full: m = !1,
    iconName: i,
    iconPosition: r = "right",
    hasChildren: u,
    noWrap: a
  } = n;
  return L(t.button, f, {
    [t.sizeSmall]: o == "small",
    [t.mobileSizeSmall]: o != "small" && s == "small",
    [t.variantPrimary]: e == "primary",
    [t.variantAccent]: e == "accent",
    [t.variantSecondary]: e == "secondary",
    [t.variantText]: e == "text",
    [t.variantInlineText]: e == "inline-text",
    [t.variantElevated]: e == "elevated",
    [t.variantLink]: e == "link",
    [t.inverted]: c,
    [t.iconRight]: i && r == "right",
    [t.iconLeft]: i && r == "left",
    [t.iconOnly]: i && !u,
    [t.noWrap]: a,
    [t.full]: m,
    [t.loading]: d
  });
}
export { nt as Button };